import { ElMessage } from 'element-plus'

/**
 * Достаёт читаемые сообщения из любой ошибки запроса.
 *
 * ApiService отклоняет промис по-разному:
 *  - 422: объект ошибки axios (error.response.data.errors / .message);
 *  - остальные статусы: обычная строка ('Ошибка 403', 'Серверная ошибка');
 *  - сеть и прочее: Error или строка.
 */
export const extractApiErrors = (error: any, fallback: string): string[] => {
  if (typeof error === 'string') {
    return [error]
  }

  const data = error && error.response && error.response.data
  if (data) {
    const messages: string[] = []
    if (data.errors && typeof data.errors === 'object') {
      Object.keys(data.errors).forEach(key => {
        const first = [].concat(data.errors[key])[0]
        if (first) {
          messages.push(String(first))
        }
      })
    }
    if (messages.length) {
      return messages
    }
    if (data.message) {
      return [String(data.message)]
    }
  }

  if (error && error.message) {
    return [String(error.message)]
  }
  return [fallback]
}

/**
 * Показывает ошибку пользователю (тихих неудач быть не должно)
 * и возвращает список сообщений, если их нужно вывести ещё и в форме.
 */
export const handleApiError = (
  error: any,
  fallback = 'Не удалось выполнить действие'
): string[] => {
  const messages = extractApiErrors(error, fallback)
  let offset = 50
  messages.slice(0, 5).forEach(message => {
    ElMessage({ offset, type: 'warning', message })
    offset += 35
  })
  return messages
}

export default handleApiError
